import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import './SiteChrome.css';

export const WEBMAIL_URL = 'https://mail.diamta.com/webmail/';

// Public site header (home, login, sign up, password pages)
const SiteHeader = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const close = () => setMenuOpen(false);

	return (
		<header className="dm-site dm-header">
			<div className="dm-container dm-header-inner">
				<Link to="/home" className="dm-brand" onClick={close}>
					<svg width="40" height="40" viewBox="0 0 40 40" aria-hidden="true">
						<path d="M20 3 L37 20 L20 37 L3 20 Z" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
						<text x="20" y="25.5" textAnchor="middle" fontSize="15" fontWeight="800" fill="currentColor">@</text>
					</svg>
					<span className="dm-brand-text">
						<span className="dm-brand-name">Diamta Mail</span>
						<span className="dm-brand-tag">Free &amp; Pro Email</span>
					</span>
				</Link>
				<nav className="dm-nav" aria-label="Main">
					<div id="dm-menu" className={'dm-nav-links' + (menuOpen ? ' is-open' : '')}>
						<HashLink smooth to="/home#features" onClick={close}>Features</HashLink>
						<HashLink smooth to="/home#pricing" onClick={close}>Pricing</HashLink>
						<HashLink smooth to="/home#setup" onClick={close}>Email app setup</HashLink>
						<a href={WEBMAIL_URL}>Webmail</a>
						<Link to="/login" onClick={close}>Log in</Link>
					</div>
					<Link to="/registration" className="dm-btn dm-btn-light" onClick={close}>Sign up free</Link>
					<button
						type="button"
						className="dm-burger"
						aria-label={menuOpen ? 'Close menu' : 'Open menu'}
						aria-expanded={menuOpen}
						aria-controls="dm-menu"
						onClick={() => setMenuOpen(!menuOpen)}
					>
						<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
							{menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
						</svg>
					</button>
				</nav>
			</div>
		</header>
	);
};

export default SiteHeader;
